import { render, staticRenderFns } from "./mobHeader.vue?vue&type=template&id=a878a96c&scoped=true"
import script from "./mobHeader.vue?vue&type=script&lang=js"
export * from "./mobHeader.vue?vue&type=script&lang=js"
import style0 from "./mobHeader.vue?vue&type=style&index=0&id=a878a96c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a878a96c",
  null
  
)

export default component.exports